import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfProductComparisonCard.module.scss';
import { Button, Card, Heading, Grid, List, RichText } from '@/components';

let cx = classNames.bind(styles);

export default function AcfProductComparisonCard(props) {
	const { productComparisonCard, attributes } = props;
	const className = attributes.className?.split(' ') || [];

	return (
		<Card id={attributes.anchor} className={cx(['ns_product-card', 'product-card', ...className])} fullHeight={attributes.fullHeight}>
			<div className={cx('product-card-head')}>
				{(productComparisonCard.eyebrow || productComparisonCard.title) && (
					<Heading level={productComparisonCard.titleElement}>
						{productComparisonCard.eyebrow && <span className={cx('product-card-eyebrow')} dangerouslySetInnerHTML={{ __html: productComparisonCard.eyebrow }} />}
						{productComparisonCard.title && (
              <span className={cx(['product-card-title-container'])}>
                <span className={cx(['product-card-title', 'is-style-heading-lead-body'])} dangerouslySetInnerHTML={{ __html: productComparisonCard.title }} />
						    {productComparisonCard.titleChip && <span className={cx(['product-card-title-chip'])} dangerouslySetInnerHTML={{ __html: productComparisonCard.titleChip }} />}
              </span>
            )}
					</Heading>
				)}
				{productComparisonCard.listDescription && <RichText html={productComparisonCard.listDescription} className={cx('product-card-list-description')} />}
				{productComparisonCard.features && productComparisonCard.features.length > 0 && (
					<List className={cx('product-card-features')} listStyle="check">
						{productComparisonCard.features.map((feature, index) => (
              <RichText elem='li' html={feature.feature} key={index} />
						))}
					</List>
				)}
			</div>
			{(productComparisonCard.price || productComparisonCard.cta) && (
				<div className={cx('product-card-foot')}>
					{productComparisonCard.price && <div className={cx('product-card-price', 'is-style-heading-lead-body')} dangerouslySetInnerHTML={{ __html: productComparisonCard.price }} />}
					{productComparisonCard.cta && (
						<div className={cx('product-card-cta-container')}>
							<Button className={cx(['product-card-button', productComparisonCard.outlinedButton && 'is-style-outline'])} href={productComparisonCard.cta.url} target={productComparisonCard.cta.target} rel={productComparisonCard.cta.target === '_blank' ? 'roreferrer noopener' : null}>
								{productComparisonCard.cta.title}
							</Button>
						</div>
					)}
				</div>
			)}
		</Card>
	);
}

AcfProductComparisonCard.fragments = {
	key: `AcfProductComparisonCardFragment`,
	entry: gql`
		fragment AcfProductComparisonCardFragment on AcfProductcomparisoncard {
			attributes {
        anchor
				className
        fullHeight
			}
			productComparisonCard {
				cta {
					target
					title
					url
				}
				eyebrow
				features {
					feature
				}
				listDescription
				outlinedButton
				price
				title
        titleChip
				titleElement
			}
		}
	`,
};

AcfProductComparisonCard.config = {
	name: 'AcfProductcomparisoncard',
};
AcfProductComparisonCard.displayName = 'AcfProductcomparisoncard';
